import { useState } from 'react';

import { AccordionAnimateBody, AccordionAnimateHeader } from '@r1-frontend/ui-react/components/accordions/AccordionAnimate';
import { SingleArrowDown } from '@r1-frontend/ui-react/components/svg/arrows';
import { H4 } from '@r1-frontend/ui-react/components/typography/heading';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import { SwitchableSubscription } from '@r1-frontend/ui-react/organisms/TariffSubscription';

import * as ST from './styled';

export interface ISubscriptionGroupItem {
    id: number,
    contentId: number,
    title: string,
    isSelected: boolean,
    cost: {
        previous: number,
        fact: number,
        final: number,
    },
    key: number,
}

interface IProps {
    groupName: string,
    title: string,
    items: Array<ISubscriptionGroupItem>,
    icon: string,
    selectedCount: number,
    onSelect: (key: number, group: string, isSelected: boolean) => () => void,
    onIconClick?: (contentId: number) => void,

    disabled?: boolean,
}

const SubscriptionsGroup = ({
    groupName,
    title,
    items = [],
    icon,
    selectedCount = 0,
    disabled = false,

    onSelect,
    onIconClick,
}: IProps) => {
    const [isShow, setIsShow] = useState(false);

    const handleIconClick = (id: number) => {
        typeof onIconClick === 'function' && onIconClick(id);
    };

    return (
        <ST.SAccordionAnimate>
            <ST.SRounderContainer $radius={24}>
                <AccordionAnimateHeader onClick={() => setIsShow(!isShow)}>
                    <ST.Head>
                        <ST.Icon src={icon}/>
                        <ST.Title>
                            <H4 $smaller={true} $withIndent={false} $inline={true}>{title}</H4>
                            <Paragraph4 $smaller={true}>{selectedCount}/{items.length}</Paragraph4>
                        </ST.Title>
                        <ST.ArrowButton
                            bType='ghost'
                            rounded
                            Icon={<SingleArrowDown/>}
                            isShow={isShow}
                            size='medium'
                        />
                    </ST.Head>
                </AccordionAnimateHeader>
                <AccordionAnimateBody isShow={isShow}>
                    <ST.SubscriptonsWrap>
                        {items.map(item => (
                            <ST.SubscriptionItem key={`TvSubscriptionIGroup_${title}_${item.id}`}>
                                <SwitchableSubscription
                                    cost={item.cost.fact}
                                    oldCost={item.cost.previous}
                                    checked={item.isSelected}
                                    onIconClick={() => handleIconClick(item.contentId)}
                                    onToggle={onSelect(item.key, groupName, item.isSelected)}
                                    disabled={disabled}
                                >{item.title}</SwitchableSubscription>
                            </ST.SubscriptionItem>
                        ))}
                    </ST.SubscriptonsWrap>
                </AccordionAnimateBody>
            </ST.SRounderContainer>
        </ST.SAccordionAnimate>
    );
};

export default  SubscriptionsGroup;
